<template>
  <div>
    <ArticleList></ArticleList>
  </div>
</template>

<script>
import ArticleList from "@/components/article/ArticleList.vue";

export default {
  name: "ArticleListView",
  components: {
    ArticleList
  }
};
</script>

<style></style>
